import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { BET_CONTROLS_BACKGROUND_BORDER_COLOR_NUM, BET_CONTROLS_BACKGROUND_COLOR_NUM, BET_CONTROLS_BACKGROUND_HIGHLIGHT_COLOR_NUM } from '../../../styles/colors';
import { Rect } from '../pixiComponents/rect';
const BACKGROUND_HEIGHT_RATIO = 0.8;
export const PokerGameControlsBackground = ({ tableAreaDimensions, gameControlsDimensions }) => {
    const x = 0;
    const y = Math.floor(tableAreaDimensions.h + gameControlsDimensions.h * (1 - BACKGROUND_HEIGHT_RATIO));
    const w = gameControlsDimensions.w;
    const h = Math.ceil(gameControlsDimensions.h * BACKGROUND_HEIGHT_RATIO);
    return (_jsxs(Container, { x: x, y: y, interactiveChildren: false, children: [_jsx(Rect, { x: 0, y: 0, w: w, h: h, fillColor: BET_CONTROLS_BACKGROUND_COLOR_NUM }), _jsx(Rect, { x: 0, y: h * 0.05, w: w, h: h * 0.2, fillColor: BET_CONTROLS_BACKGROUND_HIGHLIGHT_COLOR_NUM }), _jsx(Rect, { x: 0, y: -2, w: w, h: 4, fillColor: BET_CONTROLS_BACKGROUND_BORDER_COLOR_NUM })] }));
};
